import QuestionRepository from "../repositories/QuestionRepository";
import UserRepository from "../repositories/UserRepository";
import { IQuestion, IReportQuestion, ISearch, IQuestionImport } from "../interfaces/models";

interface ISearchQuery {
    sortField?: string,
    sortDesc?: "ASC" | "DESC",
    filterField?: string,
    filterTopics?: number[],
    query?: string,
    page?: number,
    pageSize?: number
};

export default class QuestionService {
    static search(searchQuery: ISearchQuery): Promise<{ questions: IQuestion[], totalItems: number, page: number }> {
        const { sortField, sortDesc, filterField, filterTopics, query, page, pageSize } = searchQuery;
        return QuestionRepository.search(sortField, sortDesc ? "DESC" : "ASC",
            filterField, filterTopics, query, page, pageSize);
    }

    static distributionForQuestion(question: IQuestion) {
        return QuestionRepository.getQuestionDistribution(question);
    }

    static submitResponse({ responseId }: { responseId: number }) {
        return QuestionRepository.submitResponse(responseId);
    }

    static submitRating({ questionID, rateType, rateValue }:
        { questionID: number, rateType: string, rateValue: number }) {
        return QuestionRepository.submitRating(questionID, rateType, rateValue);
    }

    static submitComment(questionID: number, commentID: number, content: string) {
        return QuestionRepository.submitComment(questionID, commentID, content);
    }

    static editComment(questionID: number, commentID: number, content: string) {
        return QuestionRepository.editComment(questionID, commentID, content);
    }

    static upvoteComment(questionID: number, commentID: number) {
        return QuestionRepository.upvoteComment(questionID, commentID);
    }

    static reportQuestion(questionId: number, reason: string[]) {
        const upload: IReportQuestion = {
            question: questionId,
            reason: reason
        };
        return QuestionRepository.uploadReport(upload);
    }

    static getReportReasons() {
        return QuestionRepository.getReportReasons();
    }

    static getReportedQuestions( { sortField, sortOrder }: { sortField: string, sortOrder: "ASC" | "DESC" }) {
        return QuestionRepository.getReportedQuestions(sortField, sortOrder);
    }

    static getReportAggregates({ reportCount }:{ reportCount: number }) {
        return QuestionRepository.getReportAggregates(reportCount);
    }
    
    static resolveReport(id: number) {
        return QuestionRepository.resolveReport(id);
    }

    static getQuestionById(questionId: number) {
        return QuestionRepository.getQuestionById(questionId);
    }

    static getRandomCourseQuestion() {
        return QuestionRepository.getRandomCourseQuestion();
    }

    static getNextRecommendedQuestion(id: number) {
        return QuestionRepository.getNextRecommendedQuestion(id);
    }

    static getSearchCacheForCourse() {
        return UserRepository.getSearchCacheForCourse();
    }
    static setSearchCacheForCourse(search: ISearch) {
        return UserRepository.setSearchCacheForCourse(search);
    }

    static deleteQuestion(id: number) {
        return QuestionRepository.deleteQuestion(id);
    }

    static getPreviousQuestions(id: number) {
        return QuestionRepository.getPreviousQuestions(id);
    }

    static getQuestionsForImport(importParams: IQuestionImport) {
        return QuestionRepository.getQuestionsForImport(importParams);
    }

    static importQuestions(importParams: IQuestionImport) {
        return QuestionRepository.importQuestions(importParams);
    }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/services/QuestionService.ts